import { resolveRetiredHaikuEngine } from "./retiredHaikuModels";

// Saved plugin and workflow settings can outlive their model selector entries.
// GPT-3.5 chat experiments and legacy voice fine-tunes are intentionally deferred.
export const RETIRED_INFERENCE_ENGINES = Object.freeze({
  "gpt-3.5-turbo-instruct": "gpt-5.6-terra",
  "gpt-4": "gpt-5.6-sol",
  "gpt-4-0613": "gpt-5.6-sol",
  "gpt-4-turbo": "gpt-5.6-sol",
  "gpt-4-turbo-2024-04-09": "gpt-5.6-sol",
  "gpt-4.1-nano": "gpt-5.6-luna",
  "gpt-4.1-nano-2025-04-14": "gpt-5.6-luna",
  "o4-mini": "gpt-5.6-terra",
  "o4-mini-2025-04-16": "gpt-5.6-terra",
});

export const resolveInferenceEngine = (engine) =>
  Object.hasOwn(RETIRED_INFERENCE_ENGINES, engine) ? RETIRED_INFERENCE_ENGINES[engine] : resolveRetiredHaikuEngine(engine);

// Persist the old model's reasoning behavior before its ID is normalized.
// Otherwise a saved GPT-4/Nano block's small output budget can be spent entirely
// on reasoning after editing or migrating it to the replacement model.
export function resolveInferenceOptions(options) {
  if (!options) return options;
  const engine = resolveInferenceEngine(options.engine);
  if (engine === options.engine) return options;
  if (!Object.hasOwn(RETIRED_INFERENCE_ENGINES, options.engine)) return { ...options, engine };
  return {
    ...options,
    engine,
    reasoningEffort: options.reasoningEffort ?? (options.engine.startsWith("o4-") ? "medium" : "none"),
  };
}
